module.exports = __webpack_public_path__ + "media/典韦.5069f6af.mp4";